import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { Menu, Transition } from "@headlessui/react";
import ReactPaginate from "react-paginate";
import { ToastContainer } from "react-toastify";
import AdminLayout from "../../component/layout/AdminLayout/AdminLayout";
//imort action file
import {
  GetEmployeelist,
  DeleteEmployee,
  UpdateEmployee,
  EmpMailStatus,
  EmployeeLoader,
} from "../../Redux/Action/EmployeeAction";
import { GetCorporateOptionlist } from "../../Redux/Action/CorporateAction";
//import sweetAlert
import Swal from "sweetalert2";
//import icone
import { AiOutlineDelete, AiOutlineMail } from "react-icons/ai";
import { RiSearch2Line } from "react-icons/ri";
import ClearFilter from "../../images/clear filter icon.png";
import LimitArrow from "../../images/LimitArrow.svg";
import Loader from "../../component/Admin/Loader";
import { BiEdit } from "react-icons/bi";
import { EditEmployeeModal } from "../../component/Modal/AdminModal/EditEmployeeModal";
import UseOutsideClick from "../../component/Admin/UseOutsideClick";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import calender from "../../images/Doctor/calender.png";
import { Filter } from "lucide-react";
import MemberListFilterSidebar from "../../component/Admin/MemberListFilterSidebar";

const Employee = () => {
  const location = useLocation();
  const history = useNavigate();
  const dispatch = useDispatch();
  const [selectpage, setselectpage] = useState("");
  const itemsPerPageOptions = [
    { value: 10, label: 10, id: 1 },
    { value: 25, label: 25, id: 2 },
    { value: 50, label: 50, id: 3 },
  ];
  const StatusOptions = [
    { value: "true", label: "Active", id: 1 },
    { value: "false", label: "Inactive", id: 2 },
  ];

  const Employeelist = useSelector(
    (state) => state?.Employelists?.EmployeList?.data
  );

  useEffect(() => {
    searchParams.delete("search");
    searchParams.delete("corporateID");
    searchParams.delete("startDate")
    searchParams.delete("endDate")
    searchParams.delete("status")
    setSearchParams(searchParams);
    const sds = location.search.slice(1).split("&");

    let object = {};
    if (location.search.includes("?")) {
     const sds = location.search.slice(1).split("&");
  sds.forEach(item => {
    const [rawKey, rawVal = ""] = item.split("=");
    const key = rawKey;
    const value = decodeURIComponent(rawVal.replace(/\+/g, " "));  
    object[key] = value;
  });
    }
    delete object.search;
    delete object.corporateID;
    delete object.startDate;
    delete object.endDate;
    delete object.status;
    dispatch(GetEmployeelist({ ...object }));
    dispatch(GetCorporateOptionlist());
    dispatch(EmployeeLoader());
  }, []);

  const [checkvalue, setcheckvalue] = useState("");
  const [Itemperpage, setItemperpage] = useState("");
  const [page, setpage] = useState("");
  const pageCount = Math.ceil(Number(Employeelist?.count) / Number(page));

  useEffect(() => {
    if (pageCount && pageCount !== Infinity) {
      setItemperpage(pageCount);
    }
  }, [Employeelist]);

  useEffect(() => {
    setpage(itemsPerPageOptions[0]?.value);
  }, []);

  // for select page data
  const onselectedpage = (item) => {
    setpage(item.value);
    const params1 = {
      ...filters,
      page: 1,
      startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
      endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
      limit: item.value,
      search: Search,
    };
    dispatch(GetEmployeelist(params1));
    dispatch(EmployeeLoader());
  };

  // for pagination
const handleFirstPage = () => {
  setselectpage(0);

  const params1 = {
    ...filters,
    page: 1,
    startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
    endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
    limit: searchParams.get("limit") ? searchParams.get("limit") : null,
    search: Search,
  };

  dispatch(GetEmployeelist(params1));
    dispatch(EmployeeLoader());
};

const handleLastPage = () => {
  const lastPage = pageCount - 1;
  setselectpage(lastPage);
  const params1 = {
    ...filters,
    page: lastPage + 1,
    startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
    endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
    limit: searchParams.get("limit") ? searchParams.get("limit") : null,
    search: Search,
  };

  dispatch(GetEmployeelist(params1));
    dispatch(EmployeeLoader());
};

  const handlePageChange = (selected) => {
    setselectpage(selected.selected);
    const params1 = {
      ...filters,
      page: selected.selected + 1,
      startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
      endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
      limit: searchParams.get("limit") ? searchParams.get("limit") : null,
      search: Search,
    };
    dispatch(GetEmployeelist(params1));
    dispatch(EmployeeLoader());
  };

  //for search filter
  const [Search, setSearch] = useState("");
  const submitsearch = (e) => {
    e?.preventDefault();
    const params = {
      ...filters,
      search: Search,
      startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
      endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
      limit: searchParams.get("limit") ? searchParams.get("limit") : null,
      page: 1,
    };
    dispatch(GetEmployeelist(params));
    dispatch(EmployeeLoader());
  };

  const [searchParams, setSearchParams] = useSearchParams();

  const removeQueryParams = () => {
    const params = {
      ...filters,
      search: '',
      startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
      endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
      limit: searchParams.get("limit") ? searchParams.get("limit") : null,
      page: 1,
    };
    dispatch(GetEmployeelist(params));
    dispatch(EmployeeLoader());
    setselectpage(0);
  };

  // for searchable-dropdwon
  const [selectedCorporate, setSelectedCorporate] = useState("");
  const [optionList, setOptionList] = useState([]);
  const [error, setError] = useState("");

function handleSelect(selectedOption) {
  setSelectedCorporate(selectedOption?.value);

  const sds = location.search.slice(1).split("&");
  let object = {};

  if (location.search.includes("?")) {
    sds.forEach((item) => {
      const [key, value] = item.split("=");
      if (key && key !== "page") {
        // Decode only the "search" parameter
        object[key] = key === "search" ? decodeURIComponent(value) : value;
      }
    });
  }

  const updatedParams = {
    ...object,
    corporateID: selectedOption?.value,
    page: 1, // force page 1 on change
  };

  // This keeps the URL valid (still shows %40 for @)
  const encodedSearch = new URLSearchParams(updatedParams).toString();

  history({
    pathname: "/admin/admin_user/employee",
    search: `?${encodedSearch}`,
  });

  dispatch(GetEmployeelist(updatedParams));
    dispatch(EmployeeLoader());
  setselectpage?.(0); // optional UI pagination reset
}


  //for mail 
  const handelMail = (id) => {
    dispatch(EmpMailStatus(id));
    dispatch(EmployeeLoader());
  }

  //for delete data in table
  const handleDelete = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Member!",
      icon: "warning",
      iconColor: "#FCDD00",
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#FCDD00",
      cancelButtonColor: "#FFFCE1",
      customClass: {
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const sds = location.search.slice(1).split("&");
        let object = {};
        if (location.search.includes("?")) {
         const sds = location.search.slice(1).split("&");
  sds.forEach(item => {
    const [rawKey, rawVal = ""] = item.split("=");
    const key = rawKey;
    const value = decodeURIComponent(rawVal.replace(/\+/g, " "));  
    object[key] = value;
  });
        }
        if (
          Employeelist?.employeeData.length === 1 &&
          object.page != undefined &&
          object.page != 1
        ) {
          const currentPage = parseInt(object.page || 1, 10);
          history({
            pathname: "/admin/admin_user/employee",
            search: `?page=${currentPage > 1 ? currentPage - 1 : 1}`,
          });
          object.page = object.page - 1;
        }
        dispatch(DeleteEmployee(index, { ...object }));
      }
    });
  };

  const Corporatename = useSelector(
    (state) => state?.corporateData?.CorporateOptionlist?.data
  );

  useEffect(() => {
    const con =
      Corporatename &&
      Corporatename?.map((c) => ({
        value: c.corporateID,
        label: c.corporateName,
        color: c.status ? "black" : "#808080",
      }));
    setOptionList(con);
  }, [Corporatename]);


  useEffect(() => {
    const newlimit = searchParams.get("limit");
    if (newlimit?.length > 0) {
      setpage(newlimit);
    }
  }, []);

  useEffect(() => {
    const newcorporateID = searchParams.get("corporateID");
    if (newcorporateID?.length > 0 && newcorporateID !== null) {
      setSelectedCorporate(newcorporateID);
    }
  }, []);

  useEffect(() => {
    const newpage = searchParams.get("page");
    if (newpage?.length > 0 && newpage !== null) {
      setselectpage(newpage - 1);
    }
  }, [searchParams]);

  const [selectionRange, setSelectionRange] = useState(null);
  const [showdelete, setshowdelete] = useState(false);
const [selectedCorporateStatus, setSelectedCorporateStatus] = useState([]);

  useEffect(() => {
    if (selectedCorporate?.length > 0 || selectionRange?.startDate || selectionRange?.endDate || selectedCorporateStatus?.length > 0 ) {
      setshowdelete(true);
    } else {
      setshowdelete(false);
    }
  }, [selectedCorporate , selectionRange, selectedCorporateStatus]);

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  //for pagination
  const reactPaginate = {
    previousLabel: "<",
    nextLabel: ">",
    breakLabel: "",
    pageCount: Itemperpage,
    onPageChange: handlePageChange,
    containerClassName: "pagination",
    previousLinkClassName: "pagination__link",
    nextLinkClassName: "pagination__link",
    disabledClassName: "pagination__link--disabled",
    activeClassName: "pagination__link--active",
    forcePage: selectpage,
  };

    // for loader
    const loader = useSelector((state) => state?.Employelists?.employeeloader);

    const [editEmpModel, setEditEmpModel] = useState(false);
    const [userDetail , setuserDetail] = useState("");
    const handleEdit = (_id) => {
      // dispatch(GetCorporateDetail(_id));
      setEditEmpModel(true);
      // setEditId(_id);
    };

const formatToIST = (ms) => {
  const date = new Date(ms);

  return new Intl.DateTimeFormat('en-IN', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  })
    .format(date)
    .replace(',', '');
};

  const [openCalender, setopenCalender] = useState(false);
  const [unixstartDate, setUnixStartDate] = useState(new Date(new Date().setUTCHours(0, 0, 0, 0))?.getTime());
  const [unixendDate, setUnixendDate] = useState(new Date(new Date().setUTCHours(23, 59, 59, 999))?.getTime());
  function formatDate(date) {
    const options = { day: "numeric", month: "short", year: "numeric" };
    return date.toLocaleDateString(undefined, options);
  }
  function formattedStartDate(d) {
    let month = String(d?.getMonth() + 1);
    let day = String(d?.getDate());
    const year = String(d?.getFullYear());

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return `${day}/${month}/${year}`;
  }

  const ref = useRef();
  UseOutsideClick(ref, () => {
    if (openCalender) {
      setopenCalender(false);
    }
  });

const handleSelection = (range) => {
  /* 1 – local component state */
  setSelectionRange({
    startDate: range.selection.startDate,
    endDate:   range.selection.endDate,
    key: "selection",
  });

  const startDateText  = formatDate(range.selection.startDate);
  const endDateText    = formatDate(range.selection.endDate);

  const unixStart = new Date(
    new Date(startDateText).setUTCHours(23, 59, 59, 999)
  ).getTime();                       // 23 :59 :59 on start day (UTC)

  const unixEnd   = new Date(endDateText).getTime() + 86_400_000; // +1 day

  setUnixStartDate(unixStart);
  setUnixendDate(unixEnd);

  /* 2 – read current query‑string (except "page") */
  const currentSearch = new URLSearchParams(location.search);
  const params = {};

  currentSearch.forEach((value, key) => {
    if (key === "page") return;           // ignore pagination
    params[key] = decodeURIComponent(value); // keep only ONE value per key
  });

  /* 3 – merge new dates + reset page */
  const updatedParams = {
    ...params,
    startDate: unixStart,
    endDate:   unixEnd,
    page:      1,
  };

  /* 4 – build a fresh query‑string */
  const newSearch = new URLSearchParams();
  Object.entries(updatedParams).forEach(([key, val]) => {
    newSearch.set(key, val);  // every value is a plain string now
  });

  /* 5 – push URL & dispatch */
  history({
    pathname: "/admin/admin_user/employee",
    search: `?${newSearch.toString()}`,
  });
  const params1 = {
    ...filters,
    search: Search,
    startDate: unixStart,
    endDate: unixEnd,
    page: 1,
    limit: searchParams.get("limit") ? searchParams.get("limit") : null,
  };
  dispatch(GetEmployeelist(params1));
    dispatch(EmployeeLoader());
};

  function handleSelectStatus(selectedOption) {
    setSelectedCorporateStatus(selectedOption.value);

    const sds = location.search.slice(1).split("&");
    let object = {};
  
    if (location.search.includes("?")) {
      sds.forEach((item) => {
        const [key, value] = item.split("=");
        if (key && key !== "page") {
          // Decode only the "search" parameter
          object[key] = key === "search" ? decodeURIComponent(value) : value;
        }
      });
    }
  
    const updatedParams = {
      ...object,
      status: selectedOption?.value, // send single value
      page: 1, // force page 1 on change
    };
    // This keeps the URL valid (still shows %40 for @)
    const encodedSearch = new URLSearchParams(updatedParams).toString();
  
    history({
      pathname: "/admin/admin_user/employee",
      search: `?${encodedSearch}`,
    });
  
    dispatch(GetEmployeelist(updatedParams));
    dispatch(EmployeeLoader());
    setselectpage?.(0); // optional UI pagination reset
  }  
  

  // filter changes
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const [filters, setFilters] = useState({
    corporateID: [],
    startDate: null,
    endDate: null,
    search: Search,
    page: 1,
  });

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    return true;
  };

  const getActiveFilterCount = () => {
    if (selectionRange?.key === "selection") {
      return filters.corporateID.length + 1;
    }
    return filters.corporateID.length + (filters.status ? 1 : 0);
  };

  const clearAllFilters = () => {
    setFilters({
      corporateID: [],
      startDate: null,
      endDate: null,
      search: Search,
      page: 1,
    });
    handleFilterChange({
      corporateID: [],
      status:''
    });
    setSelectionRange(null);
    searchParams.delete("startDate");
    searchParams.delete("endDate");
    setSearchParams(searchParams);
    setselectpage(0);
    dispatch(
      GetEmployeelist({
        corporateID: [],
        search: Search,
        page: 1,
      })
    );
    dispatch(EmployeeLoader());
    setIsSidebarOpen(false);
  };
  const handelApplyFilter = (filters) => {
    dispatch(GetEmployeelist({
      ...filters,
      search: Search,
      startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
      endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
    }));
    dispatch(EmployeeLoader());
  }; 


  return (
    <>
      {loader && (
        <div>
          <div className="fixed top-0 left-0 right-0 z-40 w-full h-full bg-black bg-opacity-50">
            <div className="z-[50] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <Loader />
            </div>
          </div>
        </div>
      )}
      <AdminLayout>
        <div className="flex flex-col h-[calc(100vh-58px)] px-5 py-5 2xl:justify-between">
          {/* {/ --------------------------------------------Search Bar---------------------------------------------------------- /} */}
          <div className="w-full p-4 mb-5 bg-white rounded-lg">
            <div className="flex flex-col items-start justify-start gap-3 xl:flex-row xl:gap-0 xl:justify-between xl:items-center">
              <div className="relative flex items-center gap-3">
                <div className="absolute top-[8px] left-[20px] text-gray-400 text-2xl">
                  <RiSearch2Line className="w-6 h-6" />
                </div>
                <form
                  onSubmit={(e) => {
                    e?.preventDefault();
                    if (Search.trim() !== "") {
                      submitsearch(e);
                    }
                  }}
                >
                  <input
                    className="h-full bg-[#FFFCE1] border rounded-[8px] py-2 pl-[50px] w-[250px] md:w-[320px] placeholder:text-[#47505F]  placeholder:text-[14px] placeholder:font-medium outline-[#FCDD00]"
                    placeholder="Search By Member, Email, Contact No"
                    value={Search}
                    type="text"
                    onChange={(e) => {
                      const inputValue = e.target.value.trimStart();
                      setSearch(inputValue);
                      if (inputValue.trim() === "") {
                        removeQueryParams();
                      }
                    }}
                  />
                </form>
                <p className="text-sm font-semibold">
                  Total Member : {Employeelist && Employeelist?.count}
                </p>
              </div>
              <div className="  flex items-center md:justify-end rounded-[8px] gap-3 mt-3 xl:mt-0">
                {getActiveFilterCount() > 0 && (
                  <div className="z-10 flex gap-3">
                    <button
                      className="bg-[#fae006] hover:bg-[#fae006]/80 py-1 px-2  rounded-[4px] del-tooltip "
                      onClick={clearAllFilters}
                    >
                      <div className="flex items-center gap-2">
                        <img src={ClearFilter} className="w-7 h-7" alt="new"></img>
                      </div>
                      <span className="text-sm del-tooltiptext font-Poppins">
                        Clear Filter
                      </span>
                    </button>
                  </div>
                )}
                <button
                  onClick={toggleSidebar}
                  className="inline-flex items-center px-4 py-2  rounded-lg text-sm font-medium  bg-[#fae006] hover:bg-[#fae006]/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                >
                  <Filter className="w-4 h-4 mr-2" />
                  Filters
                </button>
                <div className="relative">
                  <button
                    className=" bg-[#fae006] text-sm items-center flex px-4 rounded-[8px] py-2 font-medium"
                    onClick={() => setopenCalender(!openCalender)}
                  >
                    <img
                      src={calender}
                      className="mr-[12px] w-4 h-4"
                      alt="calenderimg"
                    ></img>
                    {selectionRange
                      ? `${formattedStartDate(
                          selectionRange.startDate
                        )} - ${formattedStartDate(selectionRange.endDate)}`
                      : "Select Date"}
                  </button>
                  {openCalender && (
                    <div className="absolute z-50 md:right-0" ref={ref}>
                      <DateRangePicker
                        ranges={[
                          selectionRange || {
                            startDate: new Date(),
                            endDate: new Date(),
                            key: "selection",
                          },
                        ]}
                        onChange={handleSelection}
                        rangeColors={["#FCDD00"]}
                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                        maxDate={new Date()}
                        popperProps={{
                          strategy: "fixed",
                        }}
                        direction="horizontal"
                      />
                    </div>
                  )}
                </div>
              </div>
              {error && <p className="text-[#ff0000]">{error}</p>}
            </div>
          </div>
          {/* {/ --------------------------------------------Content Table------------------------------------------------------- /} */}
          <div className="flex-1 overflow-auto scrollbar-thumb-[#FCDD00] scrollbar-thin scrollbar-track-gray-100">
            {Employeelist?.employeeData?.length === 0 ? (
              <div className="flex items-center justify-center h-full">
                <p className="text-xl font-Roboto">
                  No Member Details Available.
                </p>
              </div>
            ) : (
              <table className="corporate-table w-[100%]  text-left font-Poppins">
                <thead>
                  <tr style={{ zIndex: 5 }}>
                    <th>
                      <div className="pl-[40px] py-3 xl:py-5 min-w-[220px]">
                        Corporate Name
                      </div>
                    </th>
                    <th>
                      <div className="min-w-[170px]">Member Name</div>
                    </th>
                    <th>
                      <div className="min-w-[220px]">Email Id</div>
                    </th>
                    <th>
                      <div className="min-w-[120px]">Contact No.</div>
                    </th>
                    <th>
                      <div className="min-w-[190px]">Register Date</div>
                    </th>
                    <th>
                      <div className="min-w-[80px]">Status</div>
                    </th>
                    <th>
                      <div className="min-w-[120px]">Action</div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Employeelist?.employeeData?.map((user, index) => (
                    <tr key={index}>
                      <td className="pl-[40px] py-2 xl:py-4 h-[46px]">
                        {user?.corporateName && user.corporateName[0] ? (
                          user.corporateName[0].length > 16 ? (
                            <div className="tooltip">
                              <span className="">
                                {user.corporateName[0].substring(0, 16)}...
                              </span>
                              <span className="tooltiptext">
                                {user.corporateName[0]}
                              </span>
                            </div>
                          ) : (
                            <span className="">
                              {user.corporateName[0]}
                            </span>
                          )
                        ) : (
                          <span>-</span>
                        )}
                      </td>
                      {user?.name?.length > 16 ? (
                        <td>
                          <div className="capitalize tooltip">
                            {`${user?.name?.substring(0, 16)}...`}
                            <span className="tooltiptext">
                              {user.name}
                            </span>
                          </div>
                        </td>
                      ) : (
                        <td className="capitalize">
                          <div className="">{user.name}</div>
                        </td>
                      )}

                      {user?.email?.length > 20 ? (
                        <td>
                          <div className="tooltip">
                            {`${user?.email?.substring(0, 20)}...`}
                            <span className="tooltiptext">
                              {user.email}
                            </span>
                          </div>
                        </td>
                      ) : (
                        <td>
                          <div className="">{user.email}</div>
                        </td>
                      )}

                      <td>
                        <p className="">{user.contact}</p>
                      </td>
                      <td>
                        <p className="">
                          {formatToIST(user.created)}
                        </p>
                      </td>
                      <td>
                        {user.corporatestatus &&
                        user.corporatestatus[0] === true ? (
                          <div className="flex">
                            {/* Code block starts */}
                            <div className="relative bg-gray-200 rounded-full shadow-sm cursor-pointer">
                              <input
                                type="checkbox"
                                name="toggle"
                                id={user?._id}
                                defaultChecked={user.status == true}
                                role="switch"
                                onChange={(e) => {
                                  if (user?.status == true) {
                                    setcheckvalue(false);
                                  } else {
                                    setcheckvalue(true);
                                  }
                                  const sds = location.search
                                    .slice(1)
                                    .split("&");
                                  let object = {};
                                  if (location.search.includes("?")) {
                                    sds.map((item) => {
                                      let newItem = item.split("=");
                                      object[newItem[0]] = newItem[1];
                                    });
                                  }
                                  dispatch(
                                    UpdateEmployee(
                                      user?._id,
                                      user?.status == true ? false : true,
                                      user?.corporateID,
                                      { ...object, search: Search }
                                    )
                                  );
                                  dispatch(EmployeeLoader());
                                }}
                                value={checkvalue}
                                className={`${
                                  user.status == false ? "left-0" : "right-0"
                                } focus:outline-none checkbox w-[22px] h-[22px] mx-[3px] rounded-full bg-white absolute shadow-sm appearance-none cursor-pointer border border-transparent top-0 bottom-0 m-auto`}
                              />
                              <label
                                htmlFor={user?._id}
                                className={`${
                                  user.status == true
                                    ? "bg-[#fcdd00]"
                                    : "bg-[#dfdfdf]"
                                } block w-[50px] r-2 h-[26px] overflow-hidden rounded-full  cursor-pointer`}
                              />
                            </div>
                          </div>
                        ) : (
                          <div className="flex tooltip">
                            <span className="tooltiptext">
                              This corporate status has been deactivated.
                            </span>
                            {/* Code block starts */}
                            <div className="relative bg-gray-200 rounded-full shadow-sm cursor-pointer">
                              <input
                                type="checkbox"
                                name="toggle"
                                id={user?._id}
                                defaultChecked={user.status == true}
                                role="switch"
                                value={checkvalue}
                                className={`${
                                  user.status == false ? "left-0" : "right-0"
                                } focus:outline-none checkbox w-[22px] h-[22px] mx-[3px] rounded-full bg-white absolute shadow-sm appearance-none cursor-pointer border border-transparent top-0 bottom-0 m-auto`}
                              />
                              <label
                                htmlFor={user?._id}
                                className={`${
                                  user.status == true
                                    ? "bg-[#fcdd00]"
                                    : "bg-[#dfdfdf]"
                                } block w-[50px] r-2 h-[26px] overflow-hidden rounded-full  cursor-pointer`}
                              />
                            </div>
                          </div>
                        )}
                      </td>
                      <td>
                        <div className="flex gap-3">
                          {/* mail btn  */}
                          <div>
                            {user.corporatestatus &&
                            user.corporatestatus[0] === true &&
                            user?.status === true ? (
                              <span className="text-xl del-tooltip">
                                <BiEdit
                                  className="cursor-pointer"
                                  onClick={() => {
                                    handleEdit(user?._id);
                                    setuserDetail(user);
                                  }}
                                />
                                <span className="text-sm del-tooltiptext">
                                  Edit
                                </span>
                              </span>
                            ) : (
                              <div className="tooltip">
                                <span className="text-xl">
                                  <BiEdit className="cursor-pointer" />
                                </span>
                                <span className="text-sm tooltiptext">
                                  {user.corporatestatus &&
                                  user.corporatestatus[0] !== true
                                    ? "This Corporate status has been deactivated."
                                    : "This Member status has been deactivated."}
                                </span>
                              </div>
                            )}
                          </div>
                          <div>
                            {user.corporatestatus &&
                            user.corporatestatus[0] === true &&
                            user?.status === true ? (
                              <span className="text-xl del-tooltip">
                                <AiOutlineMail
                                  className="cursor-pointer"
                                  onClick={() => handelMail(user?._id)}
                                />
                                <span className="text-sm del-tooltiptext">
                                  Send Mail
                                </span>
                              </span>
                            ) : (
                              <div className="tooltip">
                                <span className="text-xl">
                                  <AiOutlineMail className="cursor-pointer" />
                                </span>
                                <span className="text-sm tooltiptext">
                                  {user.corporatestatus &&
                                  user.corporatestatus[0] !== true
                                    ? "This Corporate status has been deactivated."
                                    : "This Member status has been deactivated."}
                                </span>
                              </div>
                            )}
                          </div>

                          {/* delete btn  */}
                          <div className=" hover:text-[#FF0000]">
                            <span className="text-xl del-tooltip">
                              {user.corporatestatus &&
                              user.corporatestatus[0] === true &&
                              user?.status === true ? (
                                <>
                                  <AiOutlineDelete
                                    className="cursor-pointer"
                                    onClick={() => handleDelete(user?._id)}
                                  />
                                  <span className="text-sm del-tooltiptext">
                                    Delete
                                  </span>
                                </>
                              ) : (
                                <div className="text-sm tooltip">
                                  <span className="text-xl">
                                    <AiOutlineDelete className="cursor-pointer" />
                                  </span>
                                  <span className="text-sm tooltiptext">
                                    {user.corporatestatus &&
                                    user.corporatestatus[0] !== true
                                      ? "This Corporate status has been deactivated."
                                      : "This Member status has been deactivated."}
                                  </span>
                                </div>
                              )}
                            </span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            <ToastContainer />
          </div>
          {/* {/ --------------------------------------------Footer---------------------------------------------------------- /} */}
          {Employeelist?.employeeData?.length > 0 && (
            <div className="sticky bottom-0 mt-3 bg-white footer-content">
              <div className="items-center justify-between md:flex">
                <div className="flex items-center gap-2 mb-3 md:mb-0">
                  <p className="capitalize">View</p>
                  <div className="">
                    <Menu as="div" className="relative text-left">
                      <div>
                        <Menu.Button className="flex px-[10px] ml-[10px] min-h-[37px] bg-white border-2 border-[#F2F2F2] min-w-[60px] rounded-[8px] justify-between  text-sm font-poppins font-medium  items-center ">
                          <p className="text-[#47505F] font-medium font-[poppins]">
                            {page}
                          </p>
                          <img src={LimitArrow} alt="LimitArrow" />
                        </Menu.Button>
                      </div>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className="bottom-full absolute right-0 z-10 mt-2 py-2 w-[70%] rounded-[12px] bg-white shadoe-sm focus:outline-none border  mb-2">
                          {itemsPerPageOptions?.map((e) => (
                            <div key={e?.id}>
                              <Menu.Item>
                                {({ active }) => (
                                  <p
                                    className={classNames(
                                      active
                                        ? "bg-[#FFFCE1] text-[#1A1A1A]"
                                        : "",
                                      "block px-2 py-2 text-sm cursor-pointer"
                                    )}
                                    onClick={() => onselectedpage(e)}
                                  >
                                    {e?.value}
                                  </p>
                                )}
                              </Menu.Item>
                            </div>
                          ))}
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  </div>
                </div>
                {/* {/ --------------------------------------------Footer Pagination---------------------------------------------------------- */}
                <div className="flex items-center mt-3 md:mt-0">
                  <button
                    className="cursor-pointer text-[#000] text-sm h-[35px] border border-[#D1D5DB] px-[15px] py-[4.5px] md:py-[5.5px]"
                    onClick={handleFirstPage}
                  >
                    &lt;&lt;
                  </button>
                  <div className="hidden text-sm md:block">
                    <ReactPaginate
                      {...reactPaginate}
                      breakLabel="..."
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                    />
                  </div>
                  <div className="text-sm md:hidden">
                    <ReactPaginate
                      {...reactPaginate}
                      marginPagesDisplayed={0}
                      pageRangeDisplayed={1}
                    />
                  </div>
                  <button
                    className="cursor-pointer text-[#000] text-sm h-[35px] border border-[#D1D5DB] px-[15px] py-[4.5px] md:py-[5.5px]"
                    onClick={handleLastPage}
                  >
                    &gt;&gt;
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        {editEmpModel && (
          <EditEmployeeModal {...{ setEditEmpModel, userDetail,editEmpModel }} />
        )}
        {isSidebarOpen && (
          <MemberListFilterSidebar
            isOpen={isSidebarOpen}
            onClose={() => setIsSidebarOpen(false)}
            filters={filters}
            onFilterChange={handleFilterChange}
            optionList={optionList}
            selectedCorporate={selectedCorporate}
            statusOptions={StatusOptions}
            Search={Search}
            vfsMemberList={false}
            startDate={searchParams.get("startDate")}
            endDate={searchParams.get("endDate")}
            setselectpage={setselectpage}
            handelApplyFilter={handelApplyFilter}
          />
        )}

        {/* Overlay */}
        {isSidebarOpen && (
          <div
            className="fixed inset-0 z-40 transition-opacity duration-300 bg-black bg-opacity-25"
            onClick={() => setIsSidebarOpen(false)}
          />
        )}
      </AdminLayout>
    </>
  );
};
export default Employee;
